export class ApplicationListItemModel {
    submissionId: number = null;
    referenceNumber: string = null;
    grants: string[] = [];
    status: string = null;

    constructor(obj: ApplicationListItemModel = null) { if (obj) { Object.assign(this, obj); } }
}
